import { render } from "./SlideThree.vue?vue&type=template&id=58a0bfe5&scoped=true"
import script from "./SlideThree.vue?vue&type=script&lang=js"
export * from "./SlideThree.vue?vue&type=script&lang=js"

import "./SlideThree.vue?vue&type=style&index=0&id=58a0bfe5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a0bfe5"]])

export default __exports__